import { SearchFilters } from '../types/search';
import hash from './hash';
import { safeLocalStorage } from './safeStorage';

const getStorageKey = (userId: string) => `${hash(userId)}-search-filters`;

export const getStoredSearchFilters = (userId?: string): SearchFilters | undefined => {
  if (!userId) return undefined;
  const stored = safeLocalStorage.getItem(getStorageKey(userId));
  try {
    return stored ? JSON.parse(stored) : undefined;
  } catch (error) {
    // Guards against corrupt JSON in storage, not storage access (safeLocalStorage never throws).
    return undefined;
  }
};

export const setStoredSearchFilters = (userId: string, filters: SearchFilters): void => {
  safeLocalStorage.setItem(getStorageKey(userId), JSON.stringify(filters));
};

export const clearStoredSearchFilters = (userId: string): void => {
  safeLocalStorage.removeItem(getStorageKey(userId));
};
